import React from 'react';

export interface DialogContentProps extends React.HTMLAttributes<HTMLDivElement> {}

export const DialogContentBase: React.FunctionComponent<DialogContentProps> = props => (
    <div {...props} />
);
